import { apiUrl } from '../config';
import { readApiJson } from '../utils/apiResponse';

let phoneCountriesCache = null;

export async function fetchPhoneCountriesList() {
  if (phoneCountriesCache) return phoneCountriesCache;
  const res = await fetch(apiUrl('/api/geo/phone-codes'));
  if (!res.ok) {
    const err = await readApiJson(res).catch(() => ({}));
    throw new Error(err.message || 'No se pudieron cargar los códigos telefónicos');
  }
  const data = await readApiJson(res);
  const phoneCountries = Array.isArray(data?.phoneCountries) ? data.phoneCountries : [];
  phoneCountriesCache = phoneCountries;
  return phoneCountries;
}

export async function fetchPhoneCountry(country) {
  if (!country) return null;
  const params = new URLSearchParams({ country: String(country) });
  const res = await fetch(apiUrl(`/api/geo/phone-codes?${params}`));
  if (!res.ok) {
    const err = await readApiJson(res).catch(() => ({}));
    throw new Error(err.message || 'No se pudo resolver el prefijo del país');
  }
  const data = await readApiJson(res);
  return data?.selected || null;
}
